/* batida-konto-quiz.js: "Ile wiesz o Batidzie?" in Moje konto (sections/batida-konto-quiz.liquid; phase 2, 29.09).
   Batida Connect: GET /apps/connect/konto/quiz?locale=pl -> {ok, available, reason?, state, attempt?:{id,
   questions:[{id, q, answers:[3], answered?:{chosen, correct, correctIndex, trivia}}]}, result?:{score, passed, code?,
   validUntil?}} (a reload returns the same attempt); POST /apps/connect/konto/quiz/answer {attemptId, questionId,
   chosen} -> {ok, correct, correctIndex, trivia, done, result?}. One question at a time, right/wrong + the trivia after
   each answer, the result at the end (4-5 right = the code). Hidden when available:false, except reason "done" (the
   result stays visible). Polish only for now: hidden on /en. ?kontodemo=1: the questions from the section setting,
   checked in the browser, sample code. Registers with the panel (assets/batida-konto.js, window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="quiz"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {};
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k, vars) { return esc(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  var URL_GET = '/apps/connect/konto/quiz', URL_ANSWER = '/apps/connect/konto/quiz/answer';
  var CTX = null, Q = null, loading = false, wired = false, modal = null, busy = false, lastFocus = null;

  /* ---------- data ---------- */
  function demoQuiz() {
    var qs = String(T.demo_questions || '').split(/\n/).map(function (line, i) {
      var p = line.split('|').map(function (x) { return x.trim(); });
      if (p.length < 5 || !p[0]) return null;
      return { id: 'dq' + i, q: p[0], answers: [p[1], p[2], p[3]], _ok: Math.max(0, Math.min(2, (parseInt(p[4], 10) || 1) - 1)), _trivia: p[5] || '' };
    }).filter(Boolean);
    return { demo: true, available: true, state: 'new', attempt: { id: 'demo', questions: qs } };
  }
  /* peek=1 = the teaser: availability and state WITHOUT drawing an attempt (nobody gets an attempt just by opening the
     panel); the attempt itself is only asked for when the customer clicks "Zagraj" */
  function getQuiz(ctx, peek) {
    return fetch(URL_GET + '?locale=' + encodeURIComponent(ctx.LANG || 'pl') + (peek ? '&peek=1' : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) { return r.ok && j && j.ok !== false ? j : null; }); })
      .catch(function () { return null; });
  }
  function load(ctx) {
    if (ctx.DEMO) { Q = demoQuiz(); return Promise.resolve(); }
    loading = true;
    return getQuiz(ctx, true).then(function (j) {
      Q = j || { available: false, reason: 'error' };
      /* a finished quiz: its result comes with the attempt (no new draw once it is done) */
      if ((Q.state === 'done' || Q.reason === 'done') && !Q.result) return getQuiz(ctx, false).then(function (k) { if (k) Q = k; });
    }).then(function () { loading = false; });
  }
  function questions() { return (Q && Q.attempt && Q.attempt.questions) || []; }
  function nextIndex() { var qs = questions(); for (var i = 0; i < qs.length; i++) if (!qs[i].answered) return i; return -1; }
  function score() { return questions().filter(function (q) { return q.answered && q.answered.correct; }).length; }

  /* ---------- the card on Start ---------- */
  function render(ctx) {
    CTX = ctx;
    var slot = ctx.slot('start', 'quiz');
    if (!slot) return;
    /* the language comes from the server (reason "locale" until that language's questions exist); the preview uses the
       questions of the page's language (setting "Pytania do podglądu", translated) */
    if (!(F.on || ctx.DEMO)) { slot.innerHTML = ''; return; }
    if (ctx.DEMO && !String(T.demo_questions || '').trim()) { slot.innerHTML = ''; return; }
    if (!ctx.DEMO && ctx.connect && ctx.connect.features && ctx.connect.features.quiz === false) { slot.innerHTML = ''; return; }
    if (!Q) { if (!loading) load(ctx).then(function () { render(CTX); }); slot.innerHTML = ''; return; }
    var done = Q.state === 'done' || (Q.available === false && Q.reason === 'done');
    if (!done && Q.available === false) { slot.innerHTML = ''; return; }
    var html = '<span class="v7k-qz__k">' + tx('kicker') + '</span><h2 class="v7k-h2">' + tx('title') + ' <i>' + tx('title_i') + '</i></h2>';
    if (done) {
      var r = Q.result || { score: score(), passed: score() >= 4 };
      html += '<p class="v7k-sub">' + tx('done_sub', { wynik: esc(r.score) }) + '</p>';
      if (r.passed && r.code) html += '<p class="v7k-qz__code">' + esc(r.code) + '</p>' + (r.validUntil ? '<p class="v7k-small">' + tx('pass_valid', { data: esc(ctx.h.dmy(ctx.h.normYmd(r.validUntil))) }) + '</p>' : '');
      else if (r.passed && r.codePending) html += '<p class="v7k-small">' + tx('code_pending') + '</p>';
      else if (!r.passed) html += '<p class="v7k-small">' + tx('fail_text') + '</p>';
    } else {
      html += '<p class="v7k-sub">' + tx('sub') + '</p><p class="v7k-acts"><button type="button" class="v7k-btn v7k-qz__start" data-v7k-quiz-open>' +
        (Q.state === 'running' || nextIndex() > 0 ? tx('resume') : tx('start')) + '</button></p>';
      if (ctx.DEMO && T.demo_note) html += '<p class="v7k-small v7k-qz__demo">' + tx('demo_note') + '</p>';
    }
    slot.innerHTML = ctx.h.box('s7 v7k-qz', html);
    if (!wired) { wired = true; ctx.app.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-v7k-quiz-open]')) open(); }); }
  }

  /* ---------- the dialog ---------- */
  function open() {
    if (!Q) return;
    if (!Q.demo && !(Q.attempt && Q.attempt.questions && Q.attempt.questions.length)) {
      /* the first click draws the attempt (GET without peek); a reload later returns the same one */
      if (busy) return; busy = true;
      getQuiz(CTX, false).then(function (j) {
        busy = false;
        if (!j || (j.available === false && j.reason !== 'done')) { Q = j || Q; CTX.h.toast(T.err || ''); CTX.h.rerender(); return; }
        Q = j; if (Q.state === 'done' && !(Q.attempt && Q.attempt.questions)) { CTX.h.rerender(); return; }
        open();
      });
      return;
    }
    if (!questions().length) return;
    lastFocus = document.activeElement;
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'v7k-qm'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-labelledby', 'v7k-qm-q');
      document.body.appendChild(modal);
      modal.addEventListener('click', onModalClick);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
    }
    modal.hidden = false; document.documentElement.classList.add('v7k-qm-open');
    var i = nextIndex();
    if (i < 0) showResult(); else showQuestion(i);
  }
  function close() {
    if (!modal) return;
    modal.hidden = true; document.documentElement.classList.remove('v7k-qm-open');
    if (CTX) CTX.h.rerender();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function frame(inner) {
    modal.innerHTML = '<div class="v7k-qm__box"><button type="button" class="v7k-qm__x" data-qm-close aria-label="' + tx('close') + '">×</button>' + inner + '</div>';
  }
  function progress(i) {
    var qs = questions();
    return '<div class="v7k-qm__prog" aria-hidden="true">' + qs.map(function (q, k) { return '<span class="' + (k <= i ? 'on' : '') + '"></span>'; }).join('') + '</div>' +
      '<p class="v7k-small">' + tx('q_of', { n: i + 1, m: qs.length }) + '</p>';
  }
  function showQuestion(i) {
    var q = questions()[i], a = q.answered;
    var html = progress(i) + '<p class="v7k-qm__q" id="v7k-qm-q">' + esc(q.q) + '</p><div class="v7k-qm__a">' + (q.answers || []).map(function (ans, k) {
      var cls = '';
      if (a) { if (k === a.correctIndex) cls = ' is-ok'; else if (k === a.chosen) cls = ' is-bad'; }
      return '<button type="button" class="v7k-qm__opt' + cls + '" data-qm-a="' + k + '" data-qm-i="' + i + '"' + (a ? ' disabled' : '') + '>' + esc(ans) + '</button>';
    }).join('') + '</div><div class="v7k-qm__fb" role="status" aria-live="polite">';
    if (a) {
      var last = nextIndex() < 0;
      html += '<p><b>' + (a.correct ? tx('ok') : tx('bad')) + '</b></p>' + (a.trivia ? '<p class="v7k-qm__tr"><b>' + tx('trivia_label') + '</b> ' + esc(a.trivia) + '</p>' : '') +
        '<p class="v7k-acts"><button type="button" class="v7k-btn v7k-btn--dark" data-qm-next>' + (last ? tx('finish') : tx('next')) + '</button></p>';
    }
    html += '</div>';
    frame(html);
    var f = modal.querySelector(a ? '[data-qm-next]' : '[data-qm-a]'); if (f) f.focus();
  }
  function showResult() {
    var r = Q.result || { score: score(), passed: score() >= 4 };
    if (Q.demo && r.passed && !r.code) { r.code = 'PRZYKLAD-10'; r.validUntil = CTX ? CTX.h.addDays(CTX.TODAY, 30) : ''; }
    Q.result = r; Q.state = 'done';
    var html = r.passed
      ? '<p class="v7k-qm__q" id="v7k-qm-q">' + tx('pass_title', { wynik: esc(r.score) }) + '</p><p>' + tx('pass_text') + '</p>' +
        (r.code ? '<p class="v7k-qz__code v7k-qz__code--light">' + esc(r.code) + '</p>' : (r.codePending ? '<p class="v7k-small" data-qm-pending>' + tx('code_pending') + '</p>' : '')) +
        (r.validUntil && CTX ? '<p class="v7k-small">' + tx('pass_valid', { data: esc(CTX.h.dmy(CTX.h.normYmd(r.validUntil))) }) + '</p>' : '')
      : '<p class="v7k-qm__q" id="v7k-qm-q">' + tx('fail_title', { wynik: esc(r.score) }) + '</p><p>' + tx('fail_text') + '</p>';
    html += '<p class="v7k-acts"><button type="button" class="v7k-btn v7k-btn--dark" data-qm-close>' + tx('close') + '</button></p>';
    frame(html);
    /* a new code shows at once in "Twoje kody" (real codes also come back from GET konto on the next visit) */
    if (!Q.demo && r.passed && r.code && CTX && CTX.connect) {
      CTX.connect.rewards = (CTX.connect.rewards || []).filter(function (x) { return x.code !== r.code; }).concat([{ code: r.code, percent: 10, validUntil: r.validUntil || '', source: 'quiz', used: false }]);
    }
    var b = modal.querySelector('[data-qm-close]:not(.v7k-qm__x)'); if (b) b.focus();
    if (!Q.demo && r.passed && !r.code && r.codePending) pollCode(0);
  }
  /* passed, the code is being created: ask again a few times (GET without peek returns the same attempt + result) */
  function pollCode(n) {
    if (n >= 6 || !CTX) return;
    setTimeout(function () {
      getQuiz(CTX, false).then(function (j) {
        if (j && j.result && j.result.code) { Q.result = j.result; if (modal && !modal.hidden && modal.querySelector('[data-qm-pending]')) showResult(); else if (CTX) CTX.h.rerender(); }
        else pollCode(n + 1);
      });
    }, 3000);
  }
  function post(body) {
    return fetch(URL_ANSWER, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) { return { status: r.status, j: j || {} }; }); });
  }
  function answer(i, k, retried) {
    if (busy && !retried) return;
    var q = questions()[i]; if (!q || q.answered) return;
    if (Q.demo) {
      q.answered = { chosen: k, correct: k === q._ok, correctIndex: q._ok, trivia: q._trivia };
      Q.state = 'running'; showQuestion(i); return;
    }
    busy = true;
    post({ attemptId: Q.attempt.id, questionId: q.id, chosen: k }).then(function (res) {
      var j = res.j;
      /* 200 = saved; 409 "answered" = answered earlier (it returns that answer) - show it the same way */
      if ((res.status === 200 && j.ok !== false) || (res.status === 409 && j.error === 'answered' && typeof j.correctIndex === 'number')) {
        var chosen = res.status === 200 ? k : (typeof j.chosen === 'number' ? j.chosen : k);
        q.answered = { chosen: chosen, correct: !!j.correct, correctIndex: typeof j.correctIndex === 'number' ? j.correctIndex : -1, trivia: j.trivia || '' };
        Q.state = j.done ? 'done' : 'running'; if (j.result) Q.result = j.result;
        busy = false; showQuestion(i); return;
      }
      if (res.status === 409 && j.error === 'busy' && !retried) { setTimeout(function () { answer(i, k, true); }, 1500); return; }
      busy = false;
      var msg = T.err || '';
      if (res.status === 429) msg = String((CTX && CTX.T && CTX.T.err_rate) || msg).replace('{s}', Math.max(1, Math.ceil(Number(j.retryAfter) || 30)));
      if (res.status === 409 && (j.error === 'done' || j.error === 'scope')) { Q.available = j.error === 'done'; Q.state = j.error === 'done' ? 'done' : Q.state; }
      var fb = modal.querySelector('.v7k-qm__fb'); if (fb) fb.innerHTML = '<p class="v7k-form__msg">' + esc(msg) + '</p>';
    }).catch(function () {
      busy = false;
      var fb = modal.querySelector('.v7k-qm__fb'); if (fb) fb.innerHTML = '<p class="v7k-form__msg">' + tx('err') + '</p>';
    });
  }
  function onModalClick(e) {
    var t = e.target;
    if (t === modal || (t.closest && t.closest('[data-qm-close]'))) { close(); return; }
    var a = t.closest && t.closest('[data-qm-a]');
    if (a) { answer(+a.getAttribute('data-qm-i'), +a.getAttribute('data-qm-a')); return; }
    if (t.closest && t.closest('[data-qm-next]')) { var n = nextIndex(); if (n < 0) showResult(); else showQuestion(n); }
  }

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'quiz', render: render });
})();
